import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'navaar-arrow-icon',
  template: `<svg [ngStyle]="style" xmlns="http://www.w3.org/2000/svg" width="24.707" height="15.29" viewBox="0 0 24.707 15.29">
  <g id="Component_17_68" data-name="Component 17 – 68" transform="translate(0.707 0.707)">
    <line id="Line_315" data-name="Line 315" x1="6.876" y2="6.876" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
    <line id="Line_483" data-name="Line 483" x1="6.877" y1="6.876" transform="translate(0 7)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
    <line id="Line_484" data-name="Line 484" x2="24" transform="translate(0 7)" fill="none" stroke="#fff" stroke-width="1"/>
  </g>
</svg>`
})
export class ArrowIconComponent {
  @Input() public style: object = {};
  constructor() { }
}
